'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getPersonalIdValidator(country) {
    if (personalIdValidators.has(country)) {
        return personalIdValidators.get(country);
    }
    throw new Error("Unable to find personal id validator for country " + country);
}
function getPersonalIdFormatter() {
    // TODO: find a good solution to make this formatter dependant on the selected registration country
    return personalIdFormatters.get('LV');
}
var personalIdValidators = new Map();
personalIdValidators.set('LV', isLatviaPersonalIdValid);
var personalIdFormatters = new Map();
personalIdFormatters.set('LV', formatLatviaPersonalId);
/**
 * Validates Latvian personal IDs
 * @param value string - personalID.
 * @param form object - object with the date of birth (date: string)
 */
function isLatviaPersonalIdValid(value, form) {
    var date = form.date;
    if (!value) {
        return true;
    }
    var valueWithoutDash = value.replace('-', '');
    // If start with 32 is the newID version.
    if (value.startsWith('32')) {
        // check pattern (32345678901)
        var pattern = /^[32][1-9]\d{9}$/;
        var regex = new RegExp(pattern, 'g');
        var match = regex.exec(valueWithoutDash);
        if (match === null) {
            return false;
        }
    }
    else {
        if (!date) {
            return false;
        }
        // check pattern (DDMMYYXNNNZ)
        var pattern = /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[012])(\d{2})([0-2])(\d{3})(\d)$/;
        var regex = new RegExp(pattern, 'g');
        var match = regex.exec(valueWithoutDash);
        if (match === null) {
            return false;
        }
        var century = match[4] === '1' ? '19' : match[4] === '2' ? '20' : '18';
        var inputDay = match[1];
        var inputMonth = match[2];
        var inputYear = century + match[3];
        var parts = date.split('-');
        var day = parts[2];
        var month = parts[1];
        var year = parts[0];
        if (day != inputDay || inputMonth != month || inputYear != year) {
            return false;
        }
        // prettier-ignore
        var checkSumDigits = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var checkSum = 0;
        for (var index in checkSumDigits) {
            if (checkSumDigits.hasOwnProperty(index)) {
                checkSum +=
                    Number(valueWithoutDash.charAt(parseInt(index, 10))) *
                        checkSumDigits[index];
            }
        }
        checkSum = (1 - checkSum) % 11;
        checkSum += checkSum < -1 ? 11 : 0;
        //checksum should match last digit
        if (checkSum !== Number(match[6])) {
            return false;
        }
    }
    return true;
}
function formatLatviaPersonalId(alien) {
    var numbersOnly = alien.replace(/\D/g, '');
    if (numbersOnly.length !== 11) {
        return '';
    }
    return numbersOnly.substring(0, 6) + "-" + numbersOnly.substring(6);
}

exports.getPersonalIdFormatter = getPersonalIdFormatter;
exports.getPersonalIdValidator = getPersonalIdValidator;
exports.personalIdFormatters = personalIdFormatters;
exports.personalIdValidators = personalIdValidators;
